import { render } from "./forgot-password.vue?vue&type=template&id=1c049fd4"
import script from "./forgot-password.vue?vue&type=script&lang=js"
export * from "./forgot-password.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/poll/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/views/home/forgot-password.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1c049fd4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1c049fd4', __exports__)) {
    console.log('reload')
    api.reload('1c049fd4', __exports__)
  }
  
  module.hot.accept("./forgot-password.vue?vue&type=template&id=1c049fd4", () => {
    console.log('re-render')
    api.rerender('1c049fd4', render)
  })

}


export default __exports__